import { Component, OnInit } from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import { environment } from 'src/environments/environment';
import { PAGE_SIZE, MAX_SIZE } from 'src/app/onelog/common/config/common';
import {
  DEFAULT_SELECTED_OPTION_TYPE_ROYALTY_V1,
  SELECT_STATUS_TYPE_DROP_DOWN_OPTIONS,
  DEFAULT_CONTRACT_SELECTED_STATUS_ROYALTY_V1,
  DROP_DOWN_SETTING_BOOKTYPE,
  SELECT_TYPE_DROP_DOWN_OPTIONS,
  NEW_DROP_DOWN_LIST_BOOK_TYPE,
} from 'src/app/onelog/common/config/dropdown-config';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { FINANCE_ROYALTY_RATE_V1 } from 'src/app/onelog/common/config/url';

@Component({
  selector: 'app-finance-royalty-rates-v1',
  templateUrl: './finance-royalty-rates-v1.component.html',
  styleUrls: ['./finance-royalty-rates-v1.component.css'],
})
export class FinanceRoyaltyRatesV1Component implements OnInit {
  constructor(private _requestService: RequestService) {}

  apiURL = environment.sachWebURL;
  selectedproductId: string = '';
  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 0;
  showSearchLoading: boolean = false;
  pageSize: number = PAGE_SIZE;
  maxSize: number = MAX_SIZE;
  searchBtnText: string = 'Search';
  selectStatusTypeDropDownOptions: any = SELECT_STATUS_TYPE_DROP_DOWN_OPTIONS;
  DefaultselectedOptionType: string = DEFAULT_SELECTED_OPTION_TYPE_ROYALTY_V1;
  dropdownSettingsBookType: IDropdownSettings = {};
  dropdownListContractStatus: any = [];
  selectContractStatusTypeDropDownOptions: any =
    DEFAULT_CONTRACT_SELECTED_STATUS_ROYALTY_V1;
  responseData: any = [];
  contractStatusList: any = [];
  selectedContractStatusType: any = [];
  selectedContractStatusFilterType: string = 'in';
  selectedContractStatusFilter: any = [];
  publishedDateSelectedFilterData: any = [];
  selectTypeDropDownOptions: any = SELECT_TYPE_DROP_DOWN_OPTIONS;
  selectedBookType: any = [];
  dropdownListBookType: any = [];

  ngOnInit(): void {
    this.loadContractStatusList();

    this.dropdownSettingsBookType = DROP_DOWN_SETTING_BOOKTYPE;

    this.loadProducts(this.createPostData());
    this.dropdownListBookType = NEW_DROP_DOWN_LIST_BOOK_TYPE;
  }

  loadProducts(postData: any = [], url: string = FINANCE_ROYALTY_RATE_V1) {
    return this._requestService
      .postRequest(url, postData)
      .subscribe((data: {}) => {
        this.responseData = data;
        this.products = this.responseData.data;
        this.totalProducts = this.responseData.total;
        this.perPage = this.responseData.per_page;
        this.lastPage = this.responseData.last_page;
        this.currentPage = this.responseData.current_page;
        console.log(data);
        this.searchBtnText = 'Search';
        this.showSearchLoading = false;
      });
  }

  createPostData() {
    this.setStatusFilterData();

    return {
      selectedproductId: this.selectedproductId,
      selectedBookType: this.selectedBookType,
      selectedContractStatus: Object.assign(
        {},
        this.selectedContractStatusFilter
      ),
      selectedPublishedDate: Object.assign(
        {},
        this.publishedDateSelectedFilterData
      ),
    };
  }

  setStatusFilterData() {
    if (
      this.selectedContractStatusFilterType !== null &&
      this.selectedContractStatusType.length > 0
    ) {
      console.log('in contract status');
      this.selectedContractStatusFilter['selectedFilterType'] =
        this.selectedContractStatusFilterType;
      this.selectedContractStatusFilter['selected'] =
        this.selectedContractStatusType;
    }

    if (this.selectedBookType !== null && this.selectedBookType.length > 0) {
      console.log('in booktype status');
      this.selectedBookType = this.selectedBookType;
    }

    console.log(this.selectedContractStatusFilter);
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    //console.log(eventData);
    let urlParams = '?page=' + eventData.currentPage;
    this.loadProducts(
      this.createPostData(),
      `${FINANCE_ROYALTY_RATE_V1}${urlParams}`
    );
  }

  searchProduct() {
    this.searchBtnText = 'Searching...';
    this.showSearchLoading = true;

    console.log({
      selectedproductId: this.selectedproductId,
      selectedBookType: this.selectedBookType,
      selectedContractStatus: Object.assign(
        {},
        this.selectedContractStatusFilter
      ),
      selectedPublishedDate: Object.assign(
        {},
        this.publishedDateSelectedFilterData
      ),
    });

    this.setStatusFilterData();

    this.loadProducts(this.createPostData());
  }

  updateSelectedType(event: any) {
    console.log('mm', event);

    if (event.name == 'contractStatus') {
      this.selectedContractStatusFilterType = event.selectedOption;
    }

    if (event.name == 'publishedDate') {
      this.publishedDateSelectedFilterData['selectedFilterType'] =
        event.selectedOption;
    }
  }

  updateSelectedDropDown(event: Event) {
    const data: any = event;

    if (data.type == 'contractStatus') {
      if (data.action == 'selected') {
        this.selectedContractStatusType.push(data.item.item_text);
      } else {
        const index = this.selectedContractStatusType.indexOf(
          data.item.item_text
        );
        this.selectedContractStatusType.splice(index, 1);
      }
      if (data.action == 'deSelectedAll') {
        this.selectedContractStatusType = ['contracted'];
        this.selectContractStatusTypeDropDownOptions =
          DEFAULT_CONTRACT_SELECTED_STATUS_ROYALTY_V1;
      }
    }

    if (data.type == 'bookType') {
      if (data.action == 'selected') {
        this.selectedBookType.push(data.item.item_text);
      } else {
        const index = this.selectedBookType.indexOf(data.item.item_text);
        this.selectedBookType.splice(index, 1);
      }
    }
  }

  loadContractStatusList() {
    this.contractStatusList = [
      { item_id: 'new', item_text: 'new' },
      { item_id: 'contracted', item_text: 'contracted' },
      { item_id: 'cancelled', item_text: 'cancelled' },
    ];
    //console.log('contract status data');console.log(contractStatusList);
    let selectedContractStatusList: any = [];
    let defaultContractStatusList: any =
      DEFAULT_CONTRACT_SELECTED_STATUS_ROYALTY_V1;
    let tempSelectedCd: any = [];
    let contractList: any = [];

    this.contractStatusList.forEach(function (
      currentValue: any,
      index: any,
      arr: any
    ) {
      let obj1: any = {};
      obj1['item_id'] = currentValue.item_id;
      obj1['item_text'] = currentValue.item_id;
      contractList.push(obj1);
      //statusList = '';
      //console.log('me',currentValue.item_id);

      if (defaultContractStatusList.includes(currentValue.item_id)) {
        selectedContractStatusList.push(obj1);
        tempSelectedCd.push(currentValue.item_id);
      }
    });

    this.dropdownListContractStatus = contractList;
    //console.log('status data');console.log(selectedContractStatusList);
    //this.showLoader = false;
    this.selectContractStatusTypeDropDownOptions = selectedContractStatusList;
    this.selectedContractStatusType = tempSelectedCd;

    this.loadProducts(this.createPostData());
  }

  downloadReport() {
    this.setStatusFilterData();

    this._requestService.download(
      FINANCE_ROYALTY_RATE_V1,
      {
        is_download: 1,
        selectedproductId: this.selectedproductId,
        selectedBookType: this.selectedBookType,
        selectedContractStatus: Object.assign(
          {},
          this.selectedContractStatusFilter
        ),
        selectedPublishedDate: Object.assign(
          {},
          this.publishedDateSelectedFilterData
        ),
      },
      '',
      'FINANCE_ROYALTY_RATE'
    );
  }

  currencySymb: any = {
    Euro: '€',
    US_Dollar: '$',
    British_Pounds: '£',
    null: '',
  };

  getCurrencySymb(key: string): string {
    return this.currencySymb[key] || '';
  }

  updateSelectedDate(event: any) {
    //console.log(event);

    if (event.type == 'publishedDate') {
      this.publishedDateSelectedFilterData['date'] = event.dateString;
    }
  }
}
